<template>
  <portal-markup :bgColor="heroSection.heroBgColor">
    <template slot="header">
      <portal-header
        :templateId="1"
        :myBgColor="navSection.navBarColor"
        :heroBgColor="heroSection.heroBgColor"
        :transNabBar="navSection.navTransBar"
        :stickToTop="navSection.navStickToTop"
      >
        <template slot="logo">
          <header-logo
            :logoPath="navSection.navLogo"
            :navLogoType="navSection.navLogoType"
            :navLogoLabel="navSection.navLogoLabel"
          ></header-logo>
        </template>
        <template slot="profile" v-if="user">
          <header-profile
            :user="user"
            :openProfilePopup="openProfilePopup"
            :logoutUser="logoutUser"
          ></header-profile>
        </template>
        <template slot="button" v-else>
          <portal-button
            :buttonText="'Log In'"
            :buttonSection="buttonSection"
            :buttonCallback="openLoginPopup"
            :callbackParam="getCallbackParam('login')"
          ></portal-button>
        </template>
      </portal-header>
    </template>
    <template slot="hero">
      <portal-hero
        v-if="heroSection.heroDisplaySection"
        :bgColor="heroSection.heroBgColor"
      >
        <template slot="story">
          <hero-story>
            <template slot="title">
              <story-title
                :text="heroSection.heroTitleText"
                :textColor="heroSection.heroTitleTextColor"
              ></story-title>
            </template>
            <template slot="description">
              <story-description
                :text="heroSection.heroDescText"
                :textColor="heroSection.heroDescTextColor"
              ></story-description>
            </template>
          </hero-story>
        </template>
        <template slot="avatar">
          <hero-avatar
            :templateId="1"
            :mediaType="heroSection.heroMediaType"
            :avatar="heroSection.heroFeaturedLogo"
            :video="heroSection.heroFeaturedVideo"
          ></hero-avatar>
        </template>
      </portal-hero>
    </template>
    <template slot="my-courses" v-if="rMemberships.myMemberships.length">
      <portal-courses
        :tileView="bodySection.tileView"
        :bgColor="bodySection.backgroundColor"
      >
        <template slot="title">{{
          bodySection.label_2 || "My Courses"
        }}</template>
        <template slot="courses">
          <div
            v-for="(membership, index) of rMemberships.myMemberships"
            :key="index"
          >
            <courses-tile
              :cover="membership.featured_image"
              :tileView="bodySection.tileView"
              :title="membership.name"
              :description="membership.description"
              :instructor="membership.instructor"
            >
              <template slot="button">
                <portal-button
                  :class="[
                    bodySection.tileView === 'grid' ? 'w-full' : 'w-auto',
                  ]"
                  :buttonText="
                    $t('frontend_groovemember_course_edit_access_now')
                  "
                  :buttonSection="buttonSection"
                  :buttonCallback="loginToMembership"
                  :callbackParam="getCallbackParam('my-courses', membership)"
                ></portal-button>
              </template>
            </courses-tile>
          </div>
        </template>
      </portal-courses>
    </template>
    <template slot="other-courses" v-if="rMemberships.otherMemberships.length">
      <portal-courses
        :tileView="bodySection.tileView"
        :bgColor="bodySection.backgroundColor"
      >
        <template slot="title">{{
          user
            ? bodySection.label_3 || "Other Courses"
            : bodySection.label_1 || "All Courses"
        }}</template>
        <template slot="courses">
          <div
            v-for="(membership, index) of rMemberships.otherMemberships"
            :key="index"
          >
            <courses-tile
              :cover="membership.featured_image"
              :tileView="bodySection.tileView"
              :title="membership.name"
              :description="membership.description"
              :instructor="membership.instructor"
            >
              <template slot="button">
                <portal-button
                  :class="[
                    bodySection.tileView === 'grid' ? 'w-full' : 'w-auto',
                  ]"
                  :buttonText="'Learn More'"
                  :specialHover="true"
                  :buttonSection="buttonSection"
                  :buttonCallback="loginToMembership"
                  :callbackParam="getCallbackParam('other-courses', membership)"
                ></portal-button>
              </template>
            </courses-tile>
          </div>
        </template>
      </portal-courses>
    </template>
    <template slot="author">
      <portal-author :authorSection="authorSection"></portal-author>
    </template>
    <template slot="footer" v-if="footerSection.isVisible">
      <portal-footer
        :copyrights="footerSection.copyrightText"
        :aboutusLink="footerSection.aboutUsLink"
        :privacyPolicyLink="footerSection.privacyPolicyLink"
        :termsLink="footerSection.termConditionLink"
        :bgColor="footerSection.backgroundColor"
        :textColor="footerSection.textColor"
      ></portal-footer>
    </template>
  </portal-markup>
</template>
<script>
import PortalHeader from "../common/header/header";
import HeaderProfile from "../common/header/profile";
import PortalButton from "../common/button";
import HeaderLogo from "../common/header/logo";
import PortalHero from "./hero/hero";
import HeroStory from "./hero/story/story";
import StoryTitle from "../common/hero/story/title";
import StoryDescription from "../common/hero/story/description";
import HeroAvatar from "../common/hero/avatar/avatar";
import PortalCourses from "../common/courses/courses";
import CoursesTile from "../common/courses/tile";
import PortalMarkup from "../../portal-markup";
import PortalAuthor from "../common/author/author";
import PortalFooter from "../common/footer/footer";

export default {
  data() {
    return {
      groovememberUrl: "https://{subdomain}.groovemember.net/",
    };
  },
  props: {
    navSection: {
      type: Object,
      required: true,
    },
    heroSection: {
      type: Object,
      required: true,
    },
    bodySection: {
      type: Object,
      required: true,
    },
    buttonSection: {
      type: Object,
      required: true,
    },
    authorSection: {
      type: Object,
      required: true,
    },
    footerSection: {
      type: Object,
      required: true,
    },
    rMemberships: {
      type: Object,
      default: () => {
        return {
          myMemberships: [],
          otherMemberships: [],
        };
      },
    },
    openLoginPopup: {
      type: Function,
    },
    openProfilePopup: {
      type: Function,
    },
    logoutUser: {
      type: Function,
    },
    loginToMembership: {
      type: Function,
    },
    redirectToPortalHomePage: {
      type: Function,
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: null,
    },
    token: {
      type: String,
      default: null,
    },
  },
  components: {
    PortalMarkup,
    HeaderProfile,
    PortalButton,
    PortalHeader,
    HeaderLogo,
    PortalHero,
    HeroStory,
    StoryTitle,
    StoryDescription,
    HeroAvatar,
    PortalCourses,
    CoursesTile,
    PortalAuthor,
    PortalFooter,
  },
  methods: {
    getCallbackParam(type, membership = null) {
      if (this.isPreview) {
        return "";
      }
      if (type === "my-courses") {
        return `${membership.login_url}?m_id=${membership.id}&mb_id=${
          this.user ? this.user.id : ""
        }&token=${this.token}&login=true`;
      }

      if (type === "other-courses" && membership.version == 1) {
        return membership.site_url || "";
      }

      if (type === "other-courses" && membership.version == 2) {
        return membership.custom_domain == 0
          ? this.groovememberUrl.replace("{subdomain}", membership.subdomain)
          : "//" + membership.custom_domain;
      }
      return "";
    },
  },
};
</script>